import {
  MEASUREMENT_CALCULATIONS,
  TIME_BOUNDS,
  QUALITY_DOMAINS
} from '@shared/constants/checkpoint-performance-report-metric-enums';
import { PerformanceMetricValidator } from '../../validators/PerformanceMetricValidator';

const FIELD_NAME_MAP = {
  MEASUREMENT_CALCULATION: 'measurementCalculation',
  NUMERATOR: 'numerator',
  DENOMINATOR: 'denominator',
  MEASUREMENT_UNIT: 'measurementUnit',
  TIME_BOUNDS: 'timeBounds',
  TIME_FRAME: 'timeFrame',
  QUALITY_DOMAIN: 'qualityDomain',
  CUSTOM_QUALITY_DOMAIN_DEFINITION: 'customQualityDomainDefinition'
};

export const PerformanceMetricService = {
  handleOnChangeMeasurementCalculation(param, formData, validationErrors, getDefaultErrorObject) {
    const resetFields =
      param[FIELD_NAME_MAP.MEASUREMENT_CALCULATION] === MEASUREMENT_CALCULATIONS.TotalCount.Id
        ? [FIELD_NAME_MAP.NUMERATOR, FIELD_NAME_MAP.DENOMINATOR, FIELD_NAME_MAP.MEASUREMENT_UNIT]
        : [FIELD_NAME_MAP.MEASUREMENT_UNIT];

    return handleFieldChange(param, formData, validationErrors, getDefaultErrorObject, {
      conditionField: FIELD_NAME_MAP.MEASUREMENT_CALCULATION,
      conditionValue: MEASUREMENT_CALCULATIONS.TotalCount.Id,
      resetFields: resetFields,
      customCondition: true
    });
  },

  handleOnChangeTimeBounds(param, formData, validationErrors, getDefaultErrorObject) {
    return handleFieldChange(param, formData, validationErrors, getDefaultErrorObject, {
      conditionField: FIELD_NAME_MAP.TIME_BOUNDS,
      conditionValue: TIME_BOUNDS.AllTime.Id,
      resetFields: [FIELD_NAME_MAP.TIME_FRAME]
    });
  },

  handleOnChangeQualityDomain(param, formData, validationErrors, getDefaultErrorObject) {
    return handleFieldChange(param, formData, validationErrors, getDefaultErrorObject, {
      conditionField: FIELD_NAME_MAP.QUALITY_DOMAIN,
      conditionValue: QUALITY_DOMAINS.NA.Id,
      resetFields: [FIELD_NAME_MAP.CUSTOM_QUALITY_DOMAIN_DEFINITION]
    });
  },

  handleOnChangeLowerUpperLimit(param, formData, validationErrors, getNewErrorObject) {
    return handleFieldChange(param, formData, validationErrors, getNewErrorObject, {
      conditionField: Object.keys(param)[0],
      conditionValue: null,
      resetFields: [],
      validateFunction: newFormData => {
        const errors = PerformanceMetricValidator.validateLowerUpperLimit(newFormData);
        return {
          lowerLimit: getNewErrorObject(validationErrors.lowerLimit, errors),
          upperLimit: getNewErrorObject(validationErrors.upperLimit, errors)
        };
      }
    });
  },

  handleOnChangeActual(param, formData, validationErrors, getNewErrorObject) {
    const hasError = !param.actual || param.actual === '-';
    const newFormData = { ...formData, ...param };
    const newValidationErrors = {
      ...validationErrors,
      actual: getNewErrorObject(validationErrors.actual, { hasError: hasError, errorMessage: '' })
    };
    return { newFormData, newValidationErrors };
  }
};

const handleFieldChange = (param, formData, validationErrors, getDefaultErrorObject, config) => {
  const { conditionField, conditionValue, resetFields, validateFunction, customCondition } = config;
  const condition = customCondition || param[conditionField] === conditionValue;
  const newValidationErrors = {
    ...validationErrors,
    [conditionField]: getDefaultErrorObject(validationErrors[conditionField]),
    ...(condition
      ? resetFields.reduce(
          (acc, field) => ({
            ...acc,
            [field]: getDefaultErrorObject(validationErrors[field])
          }),
          {}
        )
      : {})
  };
  const newFormData = {
    ...formData,
    ...param,
    ...(condition ? resetFields.reduce((acc, field) => ({ ...acc, [field]: '' }), {}) : {})
  };
  if (validateFunction) {
    const additionalErrors = validateFunction(newFormData);
    Object.assign(newValidationErrors, additionalErrors);
  }
  return { newFormData, newValidationErrors };
};
